import React, { useState } from "react";
import { Bell, Megaphone } from "lucide-react";
import TabPageLayout from "modules/swiftboard/components/TabPageLayout";
import TemplateList from "./template-list/TemplateList";
import useUrlTab from "modules/swiftboard/components/useUrlTab";

const EmailTemplate = () => {
  const [activeTab, setActiveTab] = useUrlTab(["notification-template", "marketing-template"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));

  const Tabs = [
    {
      id: 1,
      label: "Notification Template",
      icon: <Bell size={18} />,
    },
    {
      id: 2,
      label: "Marketing Template",
      icon: <Megaphone size={18} />,
    },
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <TabPageLayout
      tabs={Tabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <TemplateList mailingFor="NOTIFICATIONS" onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <TemplateList mailingFor="MARKETING" onTotalCountChange={setTabCount(2)} />}
    </TabPageLayout>
  );
};

export default EmailTemplate;
